// removed by extract-text-webpack-plugin
module.exports = {"narrowMax":"1000","wideMax":"Infinity","narrow":"narrow","wide":"wide"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app_secchi.scss
// module id = udAy
// module chunks = 6